import { IconTypes } from '@eika/icon';
import { LinkList } from '@eika/link-list';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';

export const SavingLinkList = () => {
    const { savingLinks } = useTranslation();
    const links = useLinks();

    return (
        <LinkList className="link-list">
            <LinkList.Item href={links.mobileAndOnlineBank.url}>{savingLinks.mobileAndOnlineBank}</LinkList.Item>
            <LinkList.Item href={links.smartspar.url}>{savingLinks.smartspar}</LinkList.Item>
            <LinkList.Item
                target="_blank"
                rel="noopener noreferrer"
                href={links.redirectURL.url}
                rightIcon={IconTypes.EKSTERN_24}
            >
                {savingLinks.eika}
            </LinkList.Item>
            <LinkList.Item
                target="_blank"
                rel="noopener noreferrer"
                href={links.eit.url}
                rightIcon={IconTypes.EKSTERN_24}
            >
                {savingLinks.eit}
            </LinkList.Item>
        </LinkList>
    );
};
